import React, { createContext, useContext, useReducer } from 'react'

import { Vault } from 'services/vault'

interface State {
  loading: boolean
  vault: Vault[]
  totalPage: number
  currentPage: number
  search: string
}

interface Action {
  type: string
  payload?: any
}

const initState: State = {
  loading: false,
  vault: [],
  totalPage: 1,
  currentPage: 1,
  search: '',
}

const VaultContext = createContext<any>(null)

function reducer(state: State, { type, payload }: Action) {
  switch (type) {
    case 'SET_LOADING':
      return {
        ...state,
        loading: payload,
      }
    case 'SET_VAULT':
      return {
        ...state,
        loading: false,
        vault: payload.data,
        totalPage: payload.meta.last_page,
      }
    case 'SET_CURRENT_PAGE':
      return {
        ...state,
        currentPage: payload,
      }
    case 'SET_SEARCH':
      return {
        ...state,
        search: payload,
        currentPage: 1,
      }
    default:
      return state
  }
}

const VaultContextProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initState)

  return (
    <VaultContext.Provider value={{ ...state, dispatch }}>
      {children}
    </VaultContext.Provider>
  )
}

const useVaultContext = () => {
  return useContext(VaultContext)
}

export { VaultContextProvider as default, useVaultContext }
